export default "__VITE_ASSET__DbckVLwk__"